export default __webpack_public_path__ + "static/media/appStoreRes.169c584d.svg";